import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isSensitiveRoute, startSessionRecording, stopSessionRecording } from "@/lib/posthog";

/**
 * Pauses PostHog session replay on highly sensitive routes where masking alone
 * is insufficient (auth, profile/account, parent + household private data,
 * support/feedback messages, data deletion, admin).
 *
 * Replay stays ON for lesson, module, course, dashboard and simulator flows so
 * we can diagnose confusion, dead clicks, rage clicks, abandonment and UI
 * errors. Autocapture is suppressed on the same routes via `url_ignorelist` in
 * `posthog.init` — stopping replay alone does not stop autocapture.
 */
export default function PostHogReplayGuard() {
  const location = useLocation();

  useEffect(() => {
    if (isSensitiveRoute(location.pathname)) {
      stopSessionRecording();
    } else {
      startSessionRecording();
    }
  }, [location.pathname]);

  return null;
}
